<template>
    <module-card :nextDisabled="nextDisabled" :nextFunction="checkAnswer">
        <div class="well-hung-container">
            <div class="paper-container">
                <div class="paper">
                    {{ wellHungPrompt.prompt }}
                </div>
            </div>

            <div class="clothesline">
                <div v-for="riskLevel in wellHungRiskLevels" :key="riskLevel.id" class="clothespin" @click.stop="selectedChoice = riskLevel.id" :class="{ selected: riskLevel.id === selectedChoice }">
                    {{ riskLevel.riskLevel }}
                </div>
            </div>
        </div>

        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </module-card>
</template>

<script>
    import { shuffle } from 'lodash';

    export default {
        data() {
            return {
                selectedChoice: null,
                incorrectMessages: ['Good try, give it another shot', 'Not Quite! Try again', 'Close!']
            };
        },
        props: {
            prompt: {
                type: Number,
                required: true
            }
        },
        methods: {
            nextDisabled() {
                return this.selectedChoice === null;
            },
            checkAnswer() {
                if (this.selectedChoice === this.wellHungPrompt.riskLevel) {
                    return true;
                } else {
                    this.$refs.modalFeedback.show(false, shuffle(this.incorrectMessages)[0], null);
                    return false;
                }
            }
        },
        computed: {
            wellHungPrompt() {
                let p = parseInt(this.$store.get(`wellHungOrder@${this.prompt - 1}`));

                return this.$store.get(`content@wellHungPrompts[${p}]`);
            },
            wellHungRiskLevels() {
                return this.$store.get(`content@wellHungRiskLevels`);
            }
        }
    };
</script>

<style scoped>
    .well-hung-container {
        width: 100%;
        padding: 15px;
    }

    .paper-container {
        position: relative;
        z-index: 1;
    }

    .paper {
        background: #fff;
        padding: 4em 2em;
        position: relative;
        width: inherit;
    }

    .paper,
    .paper::before,
    .paper::after {
        /* Styles to distinguish sheets from one another */
        box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.25);
        border: 1px solid #bbb;
    }

    .paper::before,
    .paper::after {
        content: '';
        position: absolute;
        height: 95%;
        width: 99%;
        background-color: #eee;
    }

    .paper::before {
        right: 15px;
        top: 0;
        transform: rotate(-2deg);
        z-index: -1;
    }

    .paper::after {
        top: 5px;
        right: -5px;
        transform: rotate(2deg);
        z-index: -2;
    }

    .clothesline {
        position: relative;
        padding-top: 2em;
        display: flex;
        justify-content: center;
        margin-bottom: 15em;
    }

    .clothesline::before {
        content: '';
        background-image: url('~@/assets/WellHung/rope.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        height: 70px;
        width: 100%;
        position: absolute;
    }

    .clothespin {
        border: 1px solid #ccc;
        background: #fafafa;
        text-align: center;
        margin: 0 -2em 0 -2.25em;
        padding: 1.5em 0;
        font-size: 1.4em;
        width: 200px;
        max-height: 25vw;
        justify-content: center;
        position: relative;
        top: 4.5em;
    }

    .selected {
        background: #ffc;
    }

    .clothespin::before {
        position: absolute;
        content: '';
        display: block;
        height: 60px;
        width: 25px;
        top: 50%;
        margin-top: -30px;
        transform: rotate(90deg);
        right: -25px;
        background-size: contain;
    }

    .clothesline div:nth-child(1) {
        transform: rotate(-85deg) translateX(0%);
    }
    .clothesline div:nth-child(1)::before {
        background-image: url('~@/assets/WellHung/clipRed.png');
    }

    .clothesline div:nth-child(2) {
        transform: rotate(-88deg) translateX(-15%);
    }
    .clothesline div:nth-child(2)::before {
        background-image: url('~@/assets/WellHung/clipOrange.png');
    }

    .clothesline div:nth-child(3) {
        transform: rotate(-92deg) translateX(-15%);
    }
    .clothesline div:nth-child(3)::before {
        background-image: url('~@/assets/WellHung/clipYellow.png');
    }

    .clothesline div:nth-child(4) {
        transform: rotate(-95deg) translateX(0%);
    }
    .clothesline div:nth-child(4)::before {
        background-image: url('~@/assets/WellHung/clipGreen.png');
    }
</style>
